import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: ''
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const val = Math.round((context.dataset.data[context.dataIndex] / 100) * 100);
                        let suffix = ' kWh';

                        // Eigenverbrauch: Zeigt auch Selbstversorgungsquote
                        if (context.dataset.label === 'Eigenverbrauch' && context.dataset.selfSupplyPercents) {
                            const pct = context.dataset.selfSupplyPercents[context.dataIndex];
                            suffix += ' (' + pct.toFixed(1) + '% PV gedeckt)';
                        }

                        // Gesamtproduktion zeigt Summe aus Eigenverbrauch+Eingespeist
                        if (context.dataset.label === 'Eingespeist') {
                            const own = context.chart.data.datasets[0].data[context.dataIndex];
                            const totalPV = Math.round(((own + context.dataset.data[context.dataIndex]) / 100) * 100);
                            suffix += ' (Produktion gesamt: ' + totalPV + ' kWh)';
                        }

                        return context.dataset.label + ': ' + val + suffix;
                    },
                    footer: function (tooltipItems) {
                        // Summe aller Segmente im Balken
                        let total = 0;
                        tooltipItems.forEach(function(item) {
                            total += item.raw;
                        });
                        return 'Gesamt: ' + Math.round(total / 100) + ' kWh';
                    }
                }
            },
            datalabels: {
                anchor: 'top',
                color: tc.datalabelColor,
                align: 'end',
                display: true,
                formatter: function (value) {
                    // Rohwert ist in hundertstel-kWh, runde und zeige als kWh
                    return Math.round(value / 100);
                },
                font: {
                    weight: 'normal'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Monat',
                    color: tc.textColor
                }
            },
            y: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor,
                    callback: function(value) {
                        return Math.round(value / 100) + ' kWh';
                    }
                },
                title: {
                    display: true,
                    text: 'kWh',
                    color: tc.textColor
                }
            }
        }
    };
};
